import React, { useState, useEffect } from 'react';

const VARIETY_MODES = [
    {
        id: 'pantry_first',
        label: 'Pantry First',
        icon: '🏠',
        color: 'pantry',
        description: 'Minimize shopping, use what you have',
        detail: 'Pantry preference 90% • Ingredient repeat max: 5x'
    },
    {
        id: 'balanced',
        label: 'Balanced',
        icon: '⚖️',
        color: 'balanced',
        description: 'Best of both worlds',
        detail: 'Pantry preference 60% • Ingredient repeat max: 3x'
    },
    {
        id: 'explore',
        label: 'Explore',
        icon: '🧭',
        color: 'explore',
        description: 'Maximum variety, larger shopping list',
        detail: 'Pantry preference 30% • Ingredient repeat max: 2x'
    }
];

export const VarietyModeSelector = ({ value, onChange, isLoading }) => {
    const [localValue, setLocalValue] = useState(value);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleSelect = (mode) => {
        if (isLoading || mode === localValue) return;

        setIsTransitioning(true);
        setLocalValue(mode);
        onChange(mode);

        // Smooth transition for the description text
        setTimeout(() => {
            setIsTransitioning(false);
        }, 300);
    };

    const activeMode = VARIETY_MODES.find(m => m.id === localValue) || VARIETY_MODES[1];

    return (
        <div className="variety-mode-selector animate-enter">
            <div
                role="radiogroup"
                aria-label="Meal Variety Mode"
                className="variety-segments"
            >
                {VARIETY_MODES.map((mode) => (
                    <button
                        key={mode.id}
                        role="radio"
                        aria-checked={localValue === mode.id}
                        aria-label={`${mode.label} - ${mode.description}`}
                        disabled={isLoading}
                        className={`variety-segment variety-segment-${mode.color} ${localValue === mode.id ? 'active' : ''}`}
                        onClick={() => handleSelect(mode.id)}
                    >
                        <span className="text-2xl" role="img" aria-hidden="true">{mode.icon}</span>
                        <span className="text-xs font-black uppercase tracking-widest">{mode.label}</span>
                    </button>
                ))}
            </div>

            <div className={`variety-description transition-all duration-300 ${isTransitioning ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'}`}>
                <div>{activeMode.description}</div>
                <div className="variety-detail">{activeMode.detail}</div>
            </div>

            {isLoading && <div className="variety-loading-bar" />}
        </div>
    );
};
